import { LinearProgress, withStyles } from '@material-ui/core'
import i18n from 'i18next'
import { FC, Fragment } from 'react'
import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import { updateStatus } from '../../../actions/apartments'
import { UpdateStatus } from '../../../actions/types'
import {
  selectApartmentById,
  selectApartmentFilesByApartmentId
} from '../../../selectors/apartments'
import { selectApplications } from '../../../selectors/applications'
import {
  selectContentIdFromPathname,
  selectUserIdFromPathname
} from '../../../selectors/router'
import { selectIsAdminUser, selectUserByUserId } from '../../../selectors/users'
import { BucketObject } from '../../../services/storage/types'
import { MuiClasses } from '../../../types'
import { Apartment } from '../../../types/apartments'
import { IndexedApplications, StateInterface } from '../../../types/states'
import { User } from '../../../types/users'
// import Suggest from '../Stepper/Steps/Suggest'
import ApartmentInformation from './ApartmentInformation'

const styles = () => ({
  grow: {
    flexGrow: 1
  },
  toolbar: {
    float: 'right' as const
  }
})

interface ApartmentOverviewProps {
  classes: MuiClasses
  apartment: Apartment | undefined
  user: User | undefined
  files: BucketObject[]
  t: i18n.TFunction
  isAdmin: boolean
  isApartmentsLoading: boolean
  applications: IndexedApplications
  updateStatus: UpdateStatus
}

const ApartmentOverview: FC<ApartmentOverviewProps> = ({
  t,
  isAdmin,
  apartment,
  user,
  files,
  applications,
  updateStatus
}) => {

  if (!apartment) {
    return <LinearProgress />
  }
  const apartmentInformationProps = {
    t,
    files,
    apartment,
    user,
    applications,
    isAdmin,
    updateStatus
  }
  return (
    <Fragment>
      {apartment ? (
        <ApartmentInformation {...apartmentInformationProps} />
      ) : (
        <div style={{ padding: '40px 16px', textAlign: 'center' }}>
          <Typography variant='h6'>{t('apartment.apartment')}</Typography>
        </div>
      )}
    </Fragment>
  )
}

const mapStateToProps = (state: StateInterface) => {
  const apartmentId = selectContentIdFromPathname(state)
  const userId = selectUserIdFromPathname(state)
  return {
    isAdmin: selectIsAdminUser(state),
    apartment: apartmentId
      ? selectApartmentById(apartmentId)(state)
      : undefined,
    user: userId ? selectUserByUserId(userId)(state) : undefined,
    applications: selectApplications(state),
    files: apartmentId
      ? selectApartmentFilesByApartmentId(apartmentId)(state)
      : []
  }
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  updateStatus: (status: string) => dispatch(updateStatus(status))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(withTranslation()(ApartmentOverview as any)))
